<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="600px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <template v-slot:activator="{}">
        <v-btn fab depressed small @click="openDialog">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-form ref="formFinancial" v-model="valid" lazy-validation>
          <v-toolbar flat>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              $t("profileDialogFinancialTitle")
            }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-alert
              :icon="false"
              dense
              type="info"
              class="ma-0 pa-0 pl-2"
              v-if="doesOperatorBlockPix"
            >
              <v-row align="center">
                <v-col class="grow">
                  <div class="d-flex align-center">
                    <div><v-icon>mdi-alert</v-icon></div>
                    <div class="ma-2">
                      <span class="subtitle-1">
                        Depois de cadastrados, seus dados financeiros só poderão
                        ser alterados via suporte.
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-alert>
            <br v-if="doesOperatorBlockPix" />
            <p v-if="verifyBank">
              Sua chave pix deve pertencer a um dos bancos autorizados:
            </p>
            <v-autocomplete
              v-if="verifyBank"
              v-model="contact.bank"
              :items="banks"
              :rules="[rules.required]"
              label="Selecionar Banco"
              outlined
              required
              item-text="text"
              item-value="value"
              @change="updateBank"
              no-data-text="Nenhum banco encontrado"
              return-object
              :disabled="pixEditBlocked"
              clearable
            ></v-autocomplete>

            <v-select
              v-model="contact.typePix"
              :rules="[rules.required]"
              label="Tipo da Chave Pix"
              outlined
              required
              :disabled="pixEditBlocked"
              :items="items"
              item-text="label"
              item-value="value"
              @change="onTypePixChange"
            ></v-select>

            <!-- Tipo E-mail -->
            <v-text-field
              v-if="contact.typePix == 'EMAIL'"
              v-model="contact.chavePix"
              :label="labelKeyPix"
              :placeholder="PlaceHolderPix"
              :disabled="pixEditBlocked"
              outlined
              required
              type="email"
              :rules="[rules.required]"
            ></v-text-field>

            <!-- Tipo CPF EVP AND PHONE -->
            <v-text-field
              v-model="contact.chavePix"
              :label="labelKeyPix"
              :placeholder="PlaceHolderPix"
              :disabled="isUsingCpfFromRegister || pixEditBlocked"
              outlined
              required
              v-mask="maskPix"
              :rules="[rules.required]"
              v-else
            ></v-text-field>
          </v-card-text>

          <v-card-actions class="pa-5">
            <div class="flex-grow-1"></div>
            <v-btn text outlined="" @click="dialog = false">
              {{ $t("BtnCancel") }}
            </v-btn>
            <v-btn
              depressed
              color="primary"
              type="submit"
              @click.prevent="editUser"
              :disabled="disableBtn"
              :loading="loading"
            >
              {{ $t("BtnSave") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from "qs"; // convert obj in "x-www-form-urlencoded format".
import { validate } from "@/util/form-validate.js";

export default {
  name: "dialogEditContact",
  props: ["financial", "banks", "currentBank"],
  data: () => ({
    dialog: false,
    dialogTitle: "Dados Financeiros",
    loading: false,
    valid: true,
    disableBtn: true,

    // Rules Default Import
    rules: {
      required: validate.required,
    },

    items: [
      {
        label: "CPF",
        value: "CPF",
      },
      {
        label: "E-mail",
        value: "EMAIL",
      },
      {
        label: "Telefone",
        value: "PHONE",
      },
      {
        label: "Chave aleatória",
        value: "EVP",
      },
    ],
    contact: {
      typePix: "",
      chavePix: "",
    },

    // Input PIX
    labelKeyPix: "",
    PlaceHolderPix: "",
    maskPix: undefined,
    typeInput: "string",
    usingCpfFromRegister: false,
    hasEverRegisteredPixData: false,
  }),

  mounted() {
    this.getDataUser();
  },

  computed: {
    verifyBank() {
      return this.$store.state.operators.verify_bank == "1";
    },
    isUsingCpfFromRegister() {
      return this.contact.typePix === "CPF" && this.usingCpfFromRegister;
    },
    pixEditBlocked() {
      return this.financial.block_pix;
    },
    doesOperatorBlockPix() {
      return this.financial.operatorBlockPix;
    },
  },

  watch: {
    currentBank(bank) {
      this.contact.bank = bank;
    },
    dialog(val) {
      !val && this.$emit("refresh-user");
      this.getDataUser();
    },
    "contact.chavePix"(val) {
      if (this.contact.typePix === "CPF") {
        this.contact.chavePix = this.userInfo.cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );

        this.usingCpfFromRegister = true;

        this.disableBtn = false;

        return;
      }

      if (this.contact.typePix == "EMAIL") {
        if (this.validateEmail(val)) {
          this.disableBtn = false;
        }
      }
      if (this.contact.typePix == "PHONE") {
        if (val.length > 10) {
          this.disableBtn = false;
        } else {
          this.disableBtn = true;
        }
      }
      if (this.contact.typePix == "EVP" && val.length > 5) {
        this.disableBtn = false;
      }
    },
  },

  methods: {
    openDialog(e) {
      e.stopPropagation();
      e.preventDefault();

      if (this.pixEditBlocked) {
        this.$store.commit("setNotification", {
          msg: this.$t("pixEditBlocked"),
          color: "warning",
        });

        return;
      }

      this.dialog = true;
    },
    updateBank() {
      this.disableBtn = false;
    },
    // Edit User - Dados Contato
    editUser() {
      if (this.$refs.formFinancial.validate()) {
        this.loading = true;
        const params = "player/profile/editPlayer";

        if (this.contact.typePix == "CPF") {
          this.contact.chavePix = this.contact.chavePix.replace(/[^0-9]+/g, "");
        }
        if (this.contact.typePix == "PHONE") {
          this.contact.chavePix = this.contact.chavePix.replace(/[^0-9]+/g, "");
          this.contact.chavePix = `+55${this.contact.chavePix}`;
        }

        const data = {
          etapa: "Banco",
          tipo_chave: this.contact.typePix,
          chave: this.contact.chavePix,
        };

        if (this.verifyBank) {
          data.codigo_banco = this.contact.bank.value;
        }

        this.$axios
          .put(params, qs.stringify(data), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            if (parseInt(response.data.dados.verificacao_bancaria) == 0) {
              this.$emit("resetWatchBankVerification");
            }

            this.dialog = false;
            const msg = response.data.messages;
            const color = "success";
            this.$store.commit("setNotification", { msg, color });
          })
          .then(() => {
            // Register Event add_payment_info Analytics
            var paymentInfo = {
              type: this.contact.typePix,
              key: this.contact.chavePix,
            };
            this.$gtag.add_payment_info(paymentInfo);
          })
          .catch(this.NotificationErrorDefault)
          .finally(() => (this.loading = false));
      } else {
        const msg = "Existe erro(s) no formulário, revise suas informações.";
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      }
    },

    // Get Data User
    getDataUser() {
      this.userInfo = this.financial;
      //   this.contact.chavePix = this.userInfo.chave_pix;
      this.contact.typePix = this.userInfo.tipo_chave;
      this.contact.chavePix = this.userInfo.chave_pix;

      this.hasEverRegisteredPixData =
        this.financial.tipo_chave || this.financial.chave_pix;

      // Primeiro acesso e operação não tem verificação bancária
      if (!this.hasEverRegisteredPixData && !this.verifyBank) {
        this.disableBtn = false;
      } else {
        this.disableBtn = true;
      }

      this.hasEverRegisteredPixData =
        this.financial.tipo_chave || this.financial.chave_pix;

      // Primeiro acesso e operação não tem verificação bancária
      if (!this.hasEverRegisteredPixData && !this.verifyBank) {
        this.disableBtn = false;
      } else {
        this.disableBtn = true;
      }

      if (!this.hasEverRegisteredPixData) {
        this.maskPix = "###.###.###-##";
        this.contact.typePix = "CPF";
        this.contact.chavePix = this.userInfo.cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
        this.labelKeyPix = "CPF";
        this.typePix = "string";
        this.usingCpfFromRegister = true;
        return;
      }

      if (this.contact.typePix == "CPF") {
        this.maskPix = "###.###.###-##";
        this.contact.chavePix = this.userInfo.chave_pix.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
        this.labelKeyPix = "CPF";
        this.typePix = "string";
      }
      if (this.contact.typePix == "PHONE") {
        this.maskPix = "(##)#####-####";
        this.contact.chavePix = this.userInfo.chave_pix
          .replace(/d{2}(\d{2})(\d{5})(\d{4})/, "($2)$3-$4")
          .split("+55");

        this.labelKeyPix = "Telefone";
        this.contact.chavePix = this.contact.chavePix[1];
        this.typePix = "string";
      }
      if (this.contact.typePix == "EVP") {
        this.maskPix = false;
        this.labelKeyPix = "Chave aleatória";
        this.typePix = "string";
      }

      if (this.contact.bank) {
        if (this.contact.bank != this.currentBank) {
          this.contact.bank = this.currentBank;
        }
      }
    },

    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg = error.response.data.messages.error;
      const color = "warning";
      this.$store.commit("setNotification", { msg, color });
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    onTypePixChange(val) {
      if (!val) {
        return;
      }

      if (val) {
        if (val == "CPF") {
          this.disableBtn = true;
          this.labelKeyPix = "CPF";
          this.PlaceHolderPix = "000.000.000-00";
          this.maskPix = "###.###.###-##";
          this.typeInput = "string";
          this.contact.typePix = "CPF";
          this.contact.chavePix = this.userInfo.cpf.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
          );
          this.usingCpfFromRegister = true;
        }
        if (val == "EMAIL") {
          this.disableBtn = true;
          this.contact.chavePix = "";
          this.labelKeyPix = "E-mail";
          this.PlaceHolderPix = "Ex: myemail@email.com";
          this.maskPix = undefined;
          this.typeInput = "email";
        }
        if (val == "PHONE") {
          this.disableBtn = true;
          this.contact.chavePix = "";
          this.labelKeyPix = "Telefone";
          this.PlaceHolderPix = "Ex: (11) 99999-9999";
          this.maskPix = "(##)#####-####";
          this.typeInput = "string";
        }
        if (val == "EVP") {
          this.disableBtn = true;
          this.contact.chavePix = "";
          this.labelKeyPix = "EVP - Código Aleatório";
          this.PlaceHolderPix = "";
          this.maskPix = "";
          this.typeInput = "string";
        }
      }
    },
  },
};
</script>
